<template>
  <v-layout row wrap class="mb-0">
    <v-flex xs12>
      <v-layout row wrap align-center>
        <span v-if="!hideLabel" :class="{ 'pb-2': tipo == 'corrispondenza' }" class="text-xs-left text-uppercase accent--text pl-1">{{ tipo }}</span>
        <v-tooltip top>
          <v-btn slot="activator" v-if="tipo !== 'corrispondenza' && !viewMode" @click="copiaIndirizzo()" icon fab small class="text-xs-right">
            <v-icon>import_export</v-icon>
          </v-btn>
          <span>Copia indirizzo di corrispondenza</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn slot="activator" v-if="tipo !== 'corrispondenza' && !viewMode" @click="rimuoviIndirizzo()" icon fab small class="text-xs-right">
            <v-icon>delete</v-icon>
          </v-btn>
          <span>Elimina indirizzo</span>
        </v-tooltip>
      </v-layout>
    </v-flex>
    <v-flex xs12 md3>
      <v-text-field
        v-model="indirizzo.Indirizzo"
        :box="!viewMode"
        :class="{ 'readonly-field': viewMode }"
        :label="showRequired ? 'Indirizzo *' : 'Indirizzo'"
        :required="showRequired"
        :clearable="!viewMode"
        :readonly="viewMode"
        hide-details
      ></v-text-field>
    </v-flex>
    <v-flex xs12 md3>
      <v-autocomplete
        v-model="indirizzo.CittaIndirizzo"
        :items="comuni"
        :box="!viewMode"
        :class="{ 'readonly-field': viewMode }"
        :label="showRequired ? 'Città *' : 'Città'"
        :required="showRequired"
        :filter="comuniFilter"
        :clearable="!viewMode"
        :readonly="viewMode"
        item-text="COMUNE"
        item-value="COMUNE"
        dense
        hide-details
        cache-items
      ></v-autocomplete>
    </v-flex>

    <v-flex xs6 md1>
      <v-text-field
        v-model="capProvincia"
        :box="!viewMode"
        :class="{ 'readonly-field': viewMode }"
        :clearable="!viewMode"
        :readonly="viewMode"
        label="Cap"
        hide-details
      ></v-text-field>
    </v-flex>
    <v-flex xs6 md2>
      <v-autocomplete
        v-model="indirizzo.NazioneIndirizzo"
        :items="countries"
        :label="showRequired ? 'Nazione *' : 'Nazione'"
        :required="showRequired"
        :box="!viewMode"
        :class="{ 'readonly-field': viewMode }"
        :clearable="!viewMode"
        :readonly="viewMode"
        item-text="country"
        item-value="abbr"
        dense
        placeholder="Nazione"
        hide-details
      ></v-autocomplete>
    </v-flex>
    <v-flex xs6 md1>
      <v-text-field v-model="provincia" :box="!viewMode" :class="{ 'readonly-field': viewMode }" label="Provincia" hide-details readonly></v-text-field>
    </v-flex>
    <v-flex xs6 md2>
      <v-text-field
        v-model="indirizzo.LocalitaIndirizzo"
        :box="!viewMode"
        :class="{ 'readonly-field': viewMode }"
        :clearable="!viewMode"
        :readonly="viewMode"
        label="Località"
        hide-details
      ></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
  import Countries from '@/api/country';
  import Comuni from '@/api/comunigtweb.json';
  import Util from '@/util';

  import { isNullOrUndefined } from 'util';
  export default {
    props: ['indirizzo', 'tipo', 'hideLabel', 'formMode', 'showRequired'],
    data() {
      return {
        countries: Countries,
        comuni: Comuni,
        formModes: Util.enFormMode,

        oldCitta: '',
        varComune: '',
        varOldcitta: '',
      };
    },
    computed: {
      provincia: {
        get(provincia) {
          let cittaSelected = this.indirizzo.CittaIndirizzo;

          if (cittaSelected != undefined) {
            let comuneSelezionato = this.comuni.find((o) => o.COMUNE.toUpperCase() === cittaSelected.toUpperCase());
            this.varComune = comuneSelezionato.COMUNE;
            this.varOldcitta = this.oldCitta;

            if (comuneSelezionato != undefined && (this.varComune.toUpperCase() !== this.varOldcitta.toUpperCase() || this.varOldcitta.toUpperCase() == null)) {
              if (comuneSelezionato.CAP) {
                this.indirizzo.Cap = comuneSelezionato.CAP;
                this.oldCitta = comuneSelezionato.COMUNE;
              }
              this.indirizzo.ProvinciaIndirizzo = comuneSelezionato.PROVINCIA;
              return this.indirizzo.ProvinciaIndirizzo;
            }
          }
          return this.indirizzo.ProvinciaIndirizzo;
        },
        set(newValue) {
          this.indirizzo.ProvinciaIndirizzo = newValue;
        },
      },
      capProvincia: {
        get(cap) {
          let capSelected = null;
          if (this.indirizzo.CittaIndirizzo != undefined) {
            capSelected = this.indirizzo.Cap;
          } else {
            capSelected = '';
          }
          return capSelected;
        },
      },
      insertMode() {
        return this.formMode === this.formModes.INSERIMENTO;
      },
      modifyMode() {
        return this.formMode === this.formModes.MODIFICA;
      },
      viewMode() {
        return this.formMode === this.formModes.VISUALIZZAZIONE;
      },
    },
    created() {
      if (this.indirizzo.id === null) {
        delete this.indirizzo['id'];
        this.indirizzo.NazioneIndirizzo = 'IT';
      } else {
        this.oldCitta = this.indirizzo.CittaIndirizzo;
      }
    },
    methods: {
      rimuoviIndirizzo() {
        // emette evento per rimuovere indirizzo
        this.$emit('rimuovi-indirizzo');
      },
      copiaIndirizzo() {
        // copia dall'indirizzo
        this.$emit('copia-indirizzo');
      },
      comuniFilter(item, queryText, itemText) {
        const textOne = item.COMUNE.toUpperCase();
        const searchText = queryText.toUpperCase();
        return textOne.startsWith(searchText);
      },
    },
  };
</script>
